import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository, type UnassignDriverParams } from '../infra/ShipmentRepository'

export type UnassignDriverDependencies = {
  repository: ShipmentRepository
}

export function unassignShipmentDriverFactory({ repository }: UnassignDriverDependencies) {
  return async function assignDriver({ shipmentUUID, config }: UnassignDriverParams) {
    try {
      return await repository.unassignDriver({ shipmentUUID, config })
    } catch (error) {
      throw new Error('Failed to unassign the driver', { cause: error as Error })
    }
  }
}

export function unassignShipmentDriver({ shipmentUUID, config }: UnassignDriverParams) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const unassignDriver = unassignShipmentDriverFactory({ repository })

  return unassignDriver({ shipmentUUID, config })
}
